import React from 'react'
import { motion } from 'motion/react'
import Answer from './answer'

export default props => {
  
  const container = {
    hidden: { 
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        duration: 0,
        staggerChildren: 0.3
      }
    }
  }

  const item = {
    hidden: {
      opacity: 0,
      translateY: '100px',
      rotateX: '-90deg'
    },
    show: {
      opacity: 1,
      translateY: '0px',
      rotateX: '0deg',
      transition: {
        duration: 0.5
      }
    }
  }

  return <motion.div
    className="answers"
    variants={container}
    initial="hidden"
    animate="show"
  >
    {
      props.state.answers
      .map(answer => <Answer 
          { ...answer }
          item={ item }
          state={ props.state }
          dispatch={ props.dispatch }
        />
      )
    }        
  </motion.div>
}